import { config } from './fragments.config';

export const XS = config.breakpoints.xs;
export const SM = config.breakpoints.sm;
export const MD = config.breakpoints.md;
export const LG = config.breakpoints.lg;
export const XL = config.breakpoints.xl;
export const XXL = config.breakpoints.xxl;
